import { render } from "./new-landing-page.vue?vue&type=template&id=15040907&scoped=true"
import script from "./new-landing-page.vue?vue&type=script&lang=js"
export * from "./new-landing-page.vue?vue&type=script&lang=js"

import "./new-landing-page.vue?vue&type=style&index=0&id=15040907&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15040907"]])

export default __exports__